export default __webpack_public_path__ + "03e7fbed7f4b6018b783f9ef6dadcb97.svg";